(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-size-drawer')) {
  customElements.define('sb-size-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.manualStock = this.dataset.manualStock === 'true';
      this.variants = JSON.parse(this.querySelector('.sb-drawer-data').textContent);
      this.position = Number(this.dataset.position) - 1;
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('.sb-drawer-open');
      this.inlineStatus = this.querySelector('.sb-selected-availability');
      this.productionStart = this.inlineStatus?.dataset.productionStart || 'payment confirmation';
      this.estimatedDispatch = this.inlineStatus?.dataset.estimatedDispatch || '';
      this.deliveryCountry = this.inlineStatus?.dataset.deliveryCountry || '';
      this.stockDelivery = this.inlineStatus?.dataset.stockDelivery || '';
      this.mtoDelivery = this.inlineStatus?.dataset.mtoDelivery || '';
      this.mtoException = this.inlineStatus?.dataset.mtoException || '';
      this.syncPickup(this.variants.find(v => String(v.id) === String(document.getElementById(this.dataset.form)?.elements.namedItem('id')?.value)));
      this.addButton = this.querySelector('.sb-drawer-add');
      this.quantityInput = this.querySelector('.sb-quantity-input');
      this.minusButton = this.querySelector('.sb-quantity-minus');
      this.plusButton = this.querySelector('.sb-quantity-plus');
      this.minusButton.addEventListener('click', () => { if (Number(this.quantityInput.value) <= Number(this.quantityInput.min)) { this.clearSelection(); return; } this.quantityInput.stepDown(); this.commitQuantity(); });
      this.plusButton.addEventListener('click', () => { this.quantityInput.stepUp(); this.commitQuantity(); });
      this.quantityInput.addEventListener('change', () => this.commitQuantity());
      this.quantityInput.addEventListener('input', () => this.syncButton());
      this.openButton.addEventListener('click', () => { this.renderSizes(); this.clearSelection(); this.dialog.showModal(); this.timer = setInterval(() => this.syncButton(), 200); });
      this.querySelector('.sb-drawer-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => { clearInterval(this.timer); this.openButton.focus(); });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog && event.clientX < this.dialog.getBoundingClientRect().left) this.dialog.close(); });
      this.querySelector('.sb-drawer-guide').addEventListener('click', () => { this.dialog.close(); document.getElementById('SizeGuideButton-' + this.dataset.picker.replace('variant-selects-', ''))?.click(); });
      this.addButton.addEventListener('click', () => {
        const form = document.getElementById(this.dataset.form);
        const submit = form?.querySelector('[type="submit"]');
        if (!this.chosen || !form || !submit || submit.disabled || String(form.querySelector('[name="id"]')?.value) !== String(this.chosen.id)) return;
        if (!this.writeQuantity(form)) return;
        if (this.isPreorder(this.chosen)) {
          let property = form.querySelector('[name="properties[Order type]"]');
          if (!property) { property = document.createElement('input'); property.type = 'hidden'; property.name = 'properties[Order type]'; form.append(property); }
          property.disabled = false; property.value = 'Made to Order';
          let production = form.querySelector('[name="properties[Production]"]');
          if (!production) { production = document.createElement('input'); production.type = 'hidden'; production.name = 'properties[Production]'; form.append(production); }
          production.disabled = false; production.value = '15 business days';
        } else { form.querySelectorAll('[name="properties[Order type]"], [name="properties[Production]"]').forEach(property => property.disabled = true); }
        this.dialog.close();
        submit.click();
      });
    }
    syncPickup(v) { const pickup = this.closest('product-info')?.querySelector('pickup-availability'); if (pickup) { const hidden = Boolean(v && (this.isPreorder(v) || (v.managed && v.quantity <= 0))); pickup.hidden = hidden; pickup.style.display = hidden ? 'none' : ''; } }
    isPreorder(v) { return v.available && v.policy === 'continue' && (v.managed ? v.quantity <= 0 : this.manualStock); }
    status(v) { return !v.available ? 'Sold out' : this.isPreorder(v) ? 'Made to Order' : (v.managed && v.quantity > 0) || (this.manualStock && !v.managed) ? 'In stock' : 'Available'; }
    renderSizes() {
      const form = document.getElementById(this.dataset.form);
      const current = this.variants.find(v => String(v.id) === String(form?.querySelector('[name="id"]')?.value)) || this.lastVariant || this.variants[0];
      const matches = this.variants.filter(v => v.options.every((value, index) => index === this.position || value === current.options[index]));
      const list = this.querySelector('.sb-drawer-sizes'); list.replaceChildren();
      matches.forEach(v => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'sb-drawer-size'; button.disabled = !v.available; button.dataset.mto = String(this.isPreorder(v)); button.setAttribute('aria-pressed', 'false');
        const size = document.createElement('span'); size.textContent = v.options[this.position]; const status = document.createElement('small'); status.textContent = this.status(v); button.append(size, status);
        button.addEventListener('click', () => {
          const picker = document.getElementById(this.dataset.picker);
          const groups = Array.from(picker?.querySelectorAll('.product-form__input') || []);
          const group = groups[this.position]; const select = group?.querySelector('select');
          const radio = Array.from(group?.querySelectorAll('input[type="radio"]') || []).find(input => input.value === v.options[this.position]);
          if (!select && !radio) return;
          this.chosen = v;
          this.quantityInput.value = String(v.min || 1);
          list.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          if (select) { select.value = v.options[this.position]; select.dispatchEvent(new Event('change', { bubbles: true })); }
          else { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
          this.querySelector('.sb-drawer-price').textContent = v.price;
          this.querySelector('.sb-drawer-availability').textContent = this.status(v);
           this.showInline(v);
          this.querySelector('.sb-drawer-message').textContent = 'Size ' + v.options[this.position] + ' selected.';
          this.openButton.firstChild.textContent = 'Size ' + v.options[this.position] + ' ';
          this.syncButton();
        }); list.append(button);
      });
      this.querySelector('.sb-drawer-message').textContent = '';
      this.querySelector('.sb-drawer-availability').textContent = '';
      this.syncButton();
    }
    clearSelection() {
      if (this.chosen) this.lastVariant = this.chosen;
      this.chosen = null;
      this.quantityInput.value = '0';
      this.openButton.textContent = 'Select size';
      this.querySelectorAll('.sb-drawer-size').forEach(button => button.setAttribute('aria-pressed', 'false'));
      const picker = document.getElementById(this.dataset.picker);
      const group = picker?.querySelectorAll('.product-form__input')[this.position];
      const select = group?.querySelector('select');
      if (select) select.selectedIndex = -1;
      group?.querySelectorAll('input[type="radio"]').forEach(input => { input.checked = false; });
      const form = document.getElementById(this.dataset.form);
      const id = form?.querySelector('[name="id"]');
      if (id) id.value = '';
      const quantity = form?.elements.namedItem('quantity');
      if (quantity) quantity.value = '0';
      const property = form?.querySelector('[name="properties[Order type]"]');
      if (property) property.disabled = true;
      const production = form?.querySelector('[name="properties[Production]"]');
      if (production) production.disabled = true;
      this.querySelector('.sb-drawer-message').textContent = '';
      this.querySelector('.sb-drawer-availability').textContent = '';
      this.showInline(null);
      this.syncButton();
    }
    showInline(v) {
      if (!this.inlineStatus) return;
      if (!v) { this.inlineStatus.textContent = 'Select a size to see availability and estimated delivery.'; return; }
      const size = 'Size ' + v.options[this.position] + ': ';
      this.inlineStatus.textContent = (!v.available ? size + 'Sold out.' : this.isPreorder(v) ? size + 'Made to Order. Production takes 15 business days after ' + this.productionStart + '. Estimated dispatch: ' + this.estimatedDispatch + '. Estimated delivery to ' + this.deliveryCountry + ': ' + this.mtoDelivery + '.' : size + 'In stock. Normally dispatched within 1 business day after payment confirmation. Estimated delivery to ' + this.deliveryCountry + ': ' + this.stockDelivery + '.') + ' Weekends are excluded. Public holidays and customs may delay delivery.';
    }
    syncQuantity() {
      const form = document.getElementById(this.dataset.form);
      const matched = this.chosen && String(form?.querySelector('[name="id"]')?.value) === String(this.chosen.id);
      this.quantityInput.disabled = !matched;
      if (!matched) { this.minusButton.disabled = true; this.plusButton.disabled = true; return; }
      const native = form.elements.namedItem('quantity');
      const min = Math.max(1, Number(this.chosen.min) || 1);
      const step = Math.max(1, Number(this.chosen.step) || 1);
      let max = this.chosen.max == null ? Infinity : Number(this.chosen.max);
      if (this.chosen.managed && this.chosen.policy === 'deny') max = Math.min(max, this.chosen.quantity);
      if (native?.getAttribute('max')) max = Math.min(max, Number(native.getAttribute('max')));
      this.quantityInput.min = String(min); this.quantityInput.step = String(step);
      if (Number.isFinite(max)) this.quantityInput.max = String(max); else this.quantityInput.removeAttribute('max');
      this.minusButton.disabled = false;
      this.plusButton.disabled = Number(this.quantityInput.value) + step > max;
    }
    commitQuantity() {
      if (this.quantityInput.value !== '' && Number(this.quantityInput.value) <= 0) { this.clearSelection(); return; }
      this.syncQuantity();
      if (this.quantityInput.disabled) return;
      const min = Number(this.quantityInput.min); const step = Number(this.quantityInput.step);
      const max = this.quantityInput.max === '' ? Infinity : Number(this.quantityInput.max);
      let value = Math.max(min, Number(this.quantityInput.value) || min);
      value = min + Math.floor((value - min) / step) * step;
      if (value > max) value = min + Math.floor((max - min) / step) * step;
      this.quantityInput.value = String(value);
      this.syncButton();
    }
    writeQuantity(form) {
      this.commitQuantity();
      if (!this.quantityInput.checkValidity() || this.quantityInput.disabled) return false;
      let native = form.elements.namedItem('quantity');
      if (!native) { native = document.createElement('input'); native.type = 'hidden'; native.name = 'quantity'; form.append(native); }
      native.value = this.quantityInput.value;
      native.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    syncButton() {
      if (this.chosen) this.syncPickup(this.chosen);
      this.syncQuantity();
      const madeToOrder = Boolean(this.chosen && this.isPreorder(this.chosen));
      this.querySelector('.sb-mto-note').hidden = !madeToOrder;
      this.querySelector('.sb-mto-production').textContent = 'Production: 15 business days after ' + this.productionStart + '. Estimated delivery to ' + this.deliveryCountry + ': ' + this.mtoDelivery + '.';
      this.querySelector('.sb-drawer-availability').hidden = madeToOrder;
      const form = document.getElementById(this.dataset.form);
      const submit = form?.querySelector('[type="submit"]');
      this.addButton.disabled = !this.quantityInput.checkValidity() || this.quantityInput.disabled || !this.chosen || !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true' || String(form.querySelector('[name="id"]')?.value) !== String(this.chosen.id);
      this.addButton.textContent = this.chosen && this.isPreorder(this.chosen) ? 'Made to Order' : 'Add to bag';
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
